import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import autobind from 'autobind-decorator';
import constants from 'src/constants';
import appDux from 'src/redux/app/';
import PropTypes from 'prop-types';
import { Button, ErrorModalContainer } from './styled';

const { modals } = constants.errorModals;

export const mapStateToProps = (state) => ({
  type: appDux.selectors.getErrorModalType(state),
});

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      deactivateErrorModal: appDux.actions.deactivateErrorModal,
    },
    dispatch,
  );

export class ErrorModal extends PureComponent {
  static propTypes = {
    deactivateErrorModal: PropTypes.func.isRequired,
    type: PropTypes.string,
  };

  static defaultProps = {
    type: null,
  };

  @autobind
  handleButtonClick() {
    const { deactivateErrorModal, type } = this.props;
    const { onButtonClick } = modals[type];

    deactivateErrorModal();
    if (onButtonClick) onButtonClick();
  }

  render() {
    const { type, deactivateErrorModal } = this.props;
    if (type === null) return null;

    const { title, message, buttonText } = modals[type];

    return (
      <ErrorModalContainer
        isOpen
        title={title}
        message={message}
        closeButton={deactivateErrorModal}
        action={<Button onClick={this.handleButtonClick}>{buttonText}</Button>}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
